import React, { useEffect, useState } from "react";

import {
	getDataFromJwt,
	isAdmin,
	isUser,
	isVolunteer,
	replaceIdInUrl,
	toastMaker,
} from "../utils/utility";
import {
	LIST_MY_PROFILES,
	UPDATE_PROFILE,
	VIEW_MY_PROFILE,
	PAYMENT_VIA_PROFILE,
	EDIT_PROFILE,
	UPDATE_PROFILE_VISIBILITY,
	GET_PROFILE_VISIBILITY,
	DELETE_PROFILE,
} from "../API_LIST";
import matrimonyInstance from "../utils/axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Popup from "../component/section/popup";
import { useDispatch, useSelector } from "react-redux";
import StripeSubscription from "../component/payment/StripeSubscription";
import EditProfile from "./editProfile";
import {
	setPaymentUserDetails,
	setPaymentVisible,
} from "../redux/features/paymentSlice";
import ForeZeroPage from "./forezero";
import { Modal } from "bootstrap";
import { Button, ModalBody } from "react-bootstrap";

const relations = [
	"Son",
	"Daughter",
	"Brother",
	"Sister",
	"Relative",
	"Friend",
	"Self",
];

const ProfileData = [
	{ name: "First Name", key: "first_name" },
	{ name: "Last Name", key: "last_name" },
	{ name: "Birth Year", key: "birth_year" },
	{ name: "Birth Month", key: "birth_month" },
	{ name: "Gotram", key: "gothram" },
	{ name: "Birth Star", key: "birth_star" },
	{ name: "Lagna", key: "lagna" },
	{ name: "Place of Birth", key: "place_of_birth" },
	{ name: "Time of Birth", key: "time_of_birth" },
	{ name: "Height", key: "height" },
	{ name: "Weight", key: "weight" },
	{ name: "Education & School", key: "education" },
	{ name: "Resident Status", key: "resident_status" },
	{ name: "Profession", key: "profession" },
	{ name: "Current Employer", key: "current_employer" },
	{ name: "Current Location", key: "current_location" },
	{ name: "Siblings", key: "siblings" },
	{ name: "Mandatory Requirements", key: "mandatory_requirements" },
	{ name: "Other Details", key: "other_details" },
];

export default function ViewProfile() {
	const navigate = useNavigate();
	const disPatch = useDispatch();
	const [userDetails, setUserDetails] = useState();
	const userRoleId = getDataFromJwt("role");
	let navUrl;
	if (userRoleId == 1) {
		navUrl = "admin";
	} else if (userRoleId == 2) {
		navUrl = "volunteer";
	}

	const [modalIsOpen, setIsOpen] = useState(false);
	const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);

	const isPaymentVisible = useSelector(
		(state) => state.payment.isPaymentVisible,
	);

	const currentProfile = useSelector((state) => state.auth.currentProfile);

	const { id } = useParams();
	const url = useLocation();
	const isEdit = false; //url?.pathname?.contains("edit");

	function deleteProfile() {
		let url = replaceIdInUrl(DELETE_PROFILE, id);
		matrimonyInstance
			.post(url)
			.then((response) => {
				toastMaker("Profile deleted successfully", "Success");
				setTimeout(navigate(-1), 5000);
			})
			.catch((error) => {
				console.log({ error });
				toastMaker(error.response.data.message, "error");
			});
	}

	function DeleteProfile() {
		return (
			<div className="create-volunteer d-flex align-items-center">
				<div>
					<p>Are you sure you want to delete this profile?</p>
					<div className="d-flex gap-3 mt-25">
						<button variant="success" onClick={deleteProfile}>
							Yes, Delete
						</button>
						<button onClick={() => setDeleteModalIsOpen(false)}>
							No, Cancel
						</button>
					</div>
				</div>
			</div>
		);
	}
	useEffect(() => {
		let url = replaceIdInUrl(VIEW_MY_PROFILE, id);
		let objectIs;

		function getUserDetails() {
			matrimonyInstance
				.get(url)
				.then((response) => {
					objectIs = response.data;
					if (currentProfile?.account_id !== objectIs?.account_id) {
						url = replaceIdInUrl(GET_PROFILE_VISIBILITY, id);
						matrimonyInstance.get(url).then((response) => {
							objectIs = response.data;
							setUserDetails(objectIs);
							return;
						});
					} else {
						setUserDetails(objectIs);
					}
				})
				.catch((error) => {
					console.log({ error });
					toastMaker(error.response.data.message, "error");
				});
		}

		getUserDetails();
	}, []);

	function updateProfile(value) {
		let data = {
			verification_status: value,
		};
		let url = replaceIdInUrl(UPDATE_PROFILE, id);
		matrimonyInstance.put(url, data).then((response) => {
			if (response.data) {
				setUserDetails(response.data.updatedProfile);
				toastMaker(response.data.message);
			}
		});
	}

	const togglePaymentVisibility = () => {
		// disPatch(setPaymentVisible(true));
	};

	function closeModal() {
		setIsOpen(false);
	}

	// let profileStatusImage;
	// if (userDetails?.profile_verification_status === "approved") {
	//   profileStatusImage = "status-approved";
	// } else if (userDetails?.profile_verification_status === "declined") {
	//   profileStatusImage = "status-rejected";
	// } else {
	//   profileStatusImage = "status-pending";
	// }

	let paymentStatusImage;
	if (userDetails?.payment_status === "active") {
		paymentStatusImage = "payment-done";
	} else {
		paymentStatusImage = "payment-failed";
	}

	let canApprove = isAdmin() || isVolunteer();

	const ApproveDeclineProfile = (_className) => {
		return (
			<React.Fragment>
				{/* {canApprove &&
        userDetails?.profile_verification_status == "in_progress" ? (
          <div className={_className}>
            <div className="d-flex gap-3">
              <button
                className="btn-approve"
                onClick={() => updateProfile("approved")}
              >
                Approve
              </button>
              <button
                className="btn-decline"
                onClick={() => updateProfile("declined")}
              >
                Decline
              </button>
            </div>
          </div>
        ) : null} */}
			</React.Fragment>
		);
	};

	const updateVisibility = async (e) => {
		const updateKey = e.target.name;
		const updateValue = !userDetails[updateKey];

		const updateField = { [updateKey]: updateValue };

		setUserDetails({
			...userDetails,
			...updateField,
		});

		const data = { field: updateKey, value: updateValue };
		const id = userDetails?.profile_id;
		let url = replaceIdInUrl(UPDATE_PROFILE_VISIBILITY, id);
		matrimonyInstance
			.put(url, data)
			.then((response) => {
				toastMaker(response?.data?.message, "success");
			})
			.catch((error) => {
				console.log("error");
				toastMaker(error, "error");
			});
	};

	useEffect(() => {
		window?.scrollTo(0, 0);
	}, [isPaymentVisible]);

	return (
		<React.Fragment>
			<div className="dashboard-content">
				{!isPaymentVisible ? (
					<React.Fragment>
						<div className="d-flex justify-content-center">
							{userDetails && (
								<div className="view-profile-card mb-25 mt-50">
									<div className="d-flex justify-content-between align-items-center">
										<div className="d-flex gap-3 align-items-center">
											<h5 className="fw-700">
												{(userDetails?.first_name &&
													userDetails.first_name !== "hidden") ||
												(userDetails?.last_name &&
													userDetails.last_name !== "hidden") ? (
													<span>
														{userDetails?.first_name &&
														userDetails.first_name !== "hidden"
															? userDetails.first_name
															: ""}{" "}
														{userDetails?.last_name &&
														userDetails.last_name !== "hidden"
															? userDetails.last_name
															: ""}
													</span>
												) : (
													"Profile"
												)}{" "}
												Details
											</h5>
											<div className="d-flex">
												{/* <img
                            src={`../../assets/images/bat-img/${profileStatusImage}.svg`}
                            title="Profile verification status"
                          /> */}
												<img
													src={`../../assets/images/bat-img/${paymentStatusImage}.svg`}
													title="Payment status"
													className="ml-10"
												/>
											</div>
										</div>
										{ApproveDeclineProfile("is-desktop-approve-decline")}
										{isUser() &&
										currentProfile?.profile_id === userDetails?.profile_id ? (
											<img
												src="../../assets/images/bat-img/profile-edit.svg"
												className="profile-edit-icon cursor-pointer"
												width={20}
												onClick={() => {
													setIsOpen(true);
												}}
											/>
										) : null}
										{canApprove ? (
											<button
												className=" btn-decline"
												onClick={() => {
													setDeleteModalIsOpen(true);
												}}
											>
												Delete Profile
											</button>
										) : null}
									</div>
									{ApproveDeclineProfile("is-responsive-approve-decline")}
									{ProfileData?.map((item, index) => {
										const value = userDetails?.[item?.key];

										return value !== undefined ? (
											<p key={index} id="toggle-profile-data">
												<span className="key mr-10">{item?.name}:</span>
												{item?.key === "relation_id" ? (
													<span>{relations[value - 1]}</span>
												) : (
													<span>
														{value === "hidden" || value === "" ? "N/A" : value}
													</span>
												)}
											</p>
										) : null;
									})}
									{canApprove && userDetails?.MatrimonyAccount && (
										<>
											<h5 className="fw-700 mt-20">
												Profile Belongs To:{" "}
												{userDetails.MatrimonyAccount.first_name}{" "}
												{userDetails.MatrimonyAccount.last_name}
											</h5>
											<p id="toggle-profile-data">
												<span className="key mr-10">Email:</span>
												<span>
													{userDetails.MatrimonyAccount.email || "N/A"}
												</span>
											</p>
											<p id="toggle-profile-data">
												<span className="key mr-10">Phone Number:</span>
												<span>
													{userDetails.MatrimonyAccount.phone_number || "N/A"}
												</span>
											</p>
											<button
												className="button login-btn create-btn text-white text-center pl-30 pr-30"
												onClick={() =>
													navigate(
														`/${navUrl}/view-account/${userDetails.MatrimonyAccount.bat_mm_account_id}`,
													)
												}
											>
												View Account
											</button>
										</>
									)}
								</div>
							)}
						</div>
						{userDetails &&
							currentProfile?.profile_id === userDetails?.profile_id &&
							userDetails?.profile_id &&
							!canApprove &&
							(userDetails.payment_status === "unpaid" ||
								userDetails.payment_status === "expired") && (
								// userDetails.profile_verification_status === "approved" &&
								<div className="d-flex justify-content-center">
									<div className="view-profile-card mb-50">
										<button
											className="button payment-btn"
											onClick={() => disPatch(setPaymentVisible(true))}
										>
											{isPaymentVisible
												? "Hide Payment Details"
												: "Make Payment"}
										</button>
									</div>
								</div>
							)}
					</React.Fragment>
				) : (
					<React.Fragment>
						{userDetails &&
							userDetails?.profile_id &&
							!canApprove &&
							userDetails.payment_status === "unpaid" && (
								// userDetails.profile_verification_status === "approved" &&
								<div className="d-flex justify-content-center">
									<div className="view-profile-card mb-50 mt-50 pb-50">
										<div className="d-flex justify-content-end">
											<button
												className="button payment-btn"
												onClick={() => disPatch(setPaymentVisible(false))}
											>
												Back to Profile
											</button>
										</div>
										<div className="d-flex justify-content-center">
											<div style={{ width: "max-content" }}>
												<StripeSubscription
													profileId={userDetails?.profile_id}
													accountEmail={userDetails?.MatrimonyAccount.email}
												/>
											</div>
										</div>
									</div>
								</div>
							)}
					</React.Fragment>
				)}
			</div>
			<Popup
				modalIsOpen={modalIsOpen}
				closeModal={closeModal}
				html={
					<EditProfile
						isEdit={true}
						userDetails={userDetails}
						closeModal={closeModal}
						setUserDetails={setUserDetails}
					/>
				}
			/>
			<Popup
				modalIsOpen={deleteModalIsOpen}
				closeModal={() => setDeleteModalIsOpen(false)}
				html={<DeleteProfile />}
			/>
		</React.Fragment>
	);
}
